export class Server {
    constructor(
        public ServerID: string,
        public Description: string,
        public ServerGroup: string
    ) { }
}